<template>
  <b-card title="Очереди и здоровье" class="h-100">
    <b-row>
      <b-col md="6">
        <small class="text-uppercase text-muted font-weight-bold">Предложка Notion</small>
        <div class="d-flex justify-content-between font-small-3 py-25">
          <b-link :to="{ name: 'content-suggestions' }">Ожидают</b-link>
          <b-badge :variant="suggestions.pending > 0 ? 'light-warning' : 'light-secondary'">{{ formatNumber(suggestions.pending) }}</b-badge>
        </div>
        <div class="d-flex justify-content-between font-small-3 py-25">
          <span>Применено за 7 дн.</span><span>{{ formatNumber(suggestions.applied_7d) }}</span>
        </div>
        <div class="d-flex justify-content-between font-small-3 py-25">
          <span>Проигнорировано за 7 дн.</span><span>{{ formatNumber(suggestions.ignored_7d) }}</span>
        </div>

        <small class="text-uppercase text-muted font-weight-bold d-block mt-1">Sentry · 24 ч</small>
        <div v-if="!sentry || !sentry.configured" class="font-small-3 text-muted">не настроен (SENTRY_AUTH_TOKEN)</div>
        <div v-else-if="sentry.error" class="font-small-3 text-danger">API недоступен</div>
        <div v-for="project in sentryProjects" :key="project.slug" class="d-flex justify-content-between font-small-3 py-25">
          <b-link :href="project.url" target="_blank" rel="noopener noreferrer">{{ project.slug }}</b-link>
          <span>
            <b-badge :variant="project.events_24h > 0 ? 'light-danger' : 'light-secondary'">{{ formatNumber(project.events_24h) }} событий</b-badge>
            <span class="text-muted ml-50">{{ project.unresolved_issues }} issues, новых {{ project.new_issues_24h }}</span>
          </span>
        </div>
      </b-col>

      <b-col md="6">
        <small class="text-uppercase text-muted font-weight-bold">Система</small>
        <div v-for="check in checks" :key="check.label" class="d-flex justify-content-between align-items-center font-small-3 py-25">
          <span>{{ check.label }}</span>
          <span>
            <span class="text-muted mr-50">{{ check.detail }}</span>
            <feather-icon :icon="check.ok ? 'CheckCircleIcon' : 'AlertCircleIcon'" :class="check.ok ? 'text-success' : 'text-danger'" size="16" />
          </span>
        </div>

        <small class="text-uppercase text-muted font-weight-bold d-block mt-1">Админы за 7 дней · {{ admins.count }}</small>
        <div class="font-small-3 text-muted">{{ adminNames }}</div>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol, BBadge, BLink,
} from 'bootstrap-vue'
import { computed } from '@vue/composition-api'
import { formatNumber, formatDateTime } from '@/views/dashboard/sifnf/utils'

export default {
  components: {
    BCard, BRow, BCol, BBadge, BLink,
  },
  props: {
    queues: { type: Object, default: null },
    sentry: { type: Object, default: null },
  },
  setup(props) {
    const suggestions = computed(() => (props.queues && props.queues.suggestions) || {})
    const health = computed(() => (props.queues && props.queues.health) || {})
    const admins = computed(() => (props.queues && props.queues.admins_active_7d) || { count: 0, users: [] })
    const sentryProjects = computed(() => (props.sentry && props.sentry.projects) || [])

    const checks = computed(() => [
      { label: 'Redis', ok: health.value.redis_ok === true, detail: '' },
      { label: 'Failed jobs', ok: !health.value.failed_jobs, detail: formatNumber(health.value.failed_jobs) },
      { label: 'Снапшот финансов', ok: !health.value.finance_snapshot_stale, detail: formatDateTime(health.value.finance_snapshot_at) },
      { label: 'Снапшот дэшборда', ok: !health.value.dashboard_snapshot_stale, detail: formatDateTime(health.value.dashboard_snapshot_at) },
    ])

    const adminNames = computed(() => (admins.value.users || []).map(user => user.name).join(', ') || '—')

    return {
      suggestions, health, admins, sentryProjects, checks, adminNames, formatNumber,
    }
  },
}
</script>
